import { render } from "./AlarmsComponent.vue?vue&type=template&id=0b9d3d43"
import script from "./AlarmsComponent.vue?vue&type=script&lang=js"
export * from "./AlarmsComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__